import { useEffect } from "react";
import { useColorScheme } from "@mui/material/styles";

import { themeOptions } from "./Theme";

// Keeps the browser/PWA bar (<meta name="theme-color">) in sync with the active
// color scheme. The manifest's static theme_color only covers the launch splash
// (dark, the default mode); once the app runs, the bar follows the user's choice.
//
// Colors are read from the theme (background.default) so they stay in sync if the
// palette changes.
const THEME_COLOR_BY_MODE: Record<"light" | "dark", string> = {
  light:
    themeOptions.colorSchemes.light?.palette.background.default ?? "#f7f3e8",
  dark: themeOptions.colorSchemes.dark?.palette.background.default ?? "#1f2037",
};

function ThemeColorSync() {
  const { mode, systemMode } = useColorScheme();

  useEffect(() => {
    const resolved = mode === "system" ? systemMode : mode;
    const color = THEME_COLOR_BY_MODE[resolved ?? "dark"];
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
      meta.setAttribute("content", color);
    }
  }, [mode, systemMode]);

  return null;
}

export default ThemeColorSync;
